export enum ApiStatusCode {
  SUCCESS = 1,
  INVALID_TOKEN = 1140,
  INSUFFICIENT_BEAN = 1200,
  REMOTE_LOGIN = 1341,
  USER_IS_STREAMING = 1342,
  DATA_NOT_FOUND = 404,

  // STREAM
  STREAMING_ON_ANOTHER_DEVICE = 1300,
  STREAM_REPORTED = 738,
  INVALID_STREAMING_STATUS = 1506,
  CREATE_STREAM_TIMEOUT = 1301,

  // SIMULCAST
  SIMULCAST_IN_USE = 2101,
  SIMULCAST_ALREADY_EXIST = 2100,

  // USER
  USER_NOT_FOUND = 652,
  USER_REPORTED = 2010,
  USER_BANNED_BY_ADMIN = 1120,
  INCORRECT_PASSWORD = 966,
  ACCOUNT_DEACTIVE = 603,
}

export const API_ERROR_MESSAGE: { [key: number]: string } = Object.freeze({
  [ApiStatusCode.INVALID_STREAMING_STATUS]:
    'You are already streaming on another device',
  [ApiStatusCode.STREAMING_ON_ANOTHER_DEVICE]:
    'You are already streaming on another device',
  [ApiStatusCode.CREATE_STREAM_TIMEOUT]:
    'Your previous stream is being finalized, please wait for 30 seconds to start a new stream.',
  [ApiStatusCode.SIMULCAST_IN_USE]:
    'This simulcast is being selected. Please deselect first before deleting.',
  [ApiStatusCode.SIMULCAST_ALREADY_EXIST]: 'Simulcast already exists.',
  [ApiStatusCode.STREAM_REPORTED]: 'You have already reported this stream.',
  [ApiStatusCode.USER_REPORTED]: 'You have already reported this user.',
  [ApiStatusCode.ACCOUNT_DEACTIVE]: 'Account has been deactivated!',
})

export enum HttpStatusCode {
  Unauthorized = 401,
  RequestTimeout = 408,
  Conflict = 409,
  TooEarly = 425,
  TooManyRequests = 429,
  InternalServerError = 500,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
  NotFound = 404,
}

export const HTTP_ERROR_MESSAGE: { [key: number]: string } = Object.freeze({
  [HttpStatusCode.InternalServerError]: 'Internal Server Error.',
  [HttpStatusCode.NotFound]: 'Page not found.',
})

export const HTTP_ERROR_DESCRIPTION: { [key: number]: string } = Object.freeze({
  [HttpStatusCode.InternalServerError]:
    'Something went wrong. Please try again later.',
  [HttpStatusCode.NotFound]:
    'Sorry, we couldn’t find the page you’re looking for.',
})

export const RETRY_STATUS_CODES = [
  HttpStatusCode.RequestTimeout,
  HttpStatusCode.Conflict,
  HttpStatusCode.TooEarly,
  HttpStatusCode.TooManyRequests,
  HttpStatusCode.InternalServerError,
  HttpStatusCode.BadGateway,
  HttpStatusCode.ServiceUnavailable,
  HttpStatusCode.GatewayTimeout,
]

export const RETRY_COUNT = 5

export const DEFAULT_PAGINATION_LIMIT = 20
